import { PublicClientApplication } from "@azure/msal-browser";
import { entra } from "./entra";

export const loginRequest = { scopes: [entra.scope] };

export const pca = new PublicClientApplication({
  auth: {
    clientId: entra.clientId,
    authority: `https://login.microsoftonline.com/${entra.tenantId}`,
    redirectUri: `${window.location.origin}/ops`,
    postLogoutRedirectUri: `${window.location.origin}/ops`,
  },
  cache: {
    cacheLocation: "localStorage",
  },
});

export const pcaReady = pca.initialize().then(async () => {
  await pca.handleRedirectPromise();
  return pca;
});
